import React from 'react'
import style from '../../addData.module.css'
import { Modal } from 'react-bootstrap'
import axios from 'axios'
import { API_CONSTANTS } from '../../../../API_CONSTANTS'
import { useDispatch } from 'react-redux'
export default function Edit({ name }) {
  const [modalShow, setModalShow] = React.useState(false)
  const [value, setValue] = React.useState('')
  const [loading, setLoading] = React.useState(false)
  const dispatch = useDispatch()
  const editingData = () => {
    setLoading(true)
    axios
      .patch(
        `${API_CONSTANTS.BASEURL_1}admin/settings`,
        {
          name: name,
          new_name: value,
          type: 'Services',
        },
        {
          headers: API_CONSTANTS.headers(),
        }
      )
      .then((res) => {
        dispatch({
          type: 'getDataSlice/editService',
          payload: {
            lastValue: name,
            newName: value,
          },
        })
        setValue('')
        setLoading(false)
        setModalShow(false)
      })
      .catch((error) => {
        alert(error.response.data.message)
        setLoading(false)
      })
  }
  return (
    <>
      <button
        className={style.button + ' ' + 'btn'}
        onClick={() => setModalShow(true)}
      >
        <i className='fas fa-pencil-alt' style={{ color: '#8E8E8E' }}></i>
      </button>
      <Modal
        size='md'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={modalShow}
        onHide={() => setModalShow(false)}
      >
        <Modal.Header closeButton style={{ border: 'none' }}>
          <Modal.Title id='contained-modal-title-vcenter'>
            Edit: {name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='d-flex w-100'>
            <input
              type='text'
              placeholder='Edit service name'
              value={value}
              className='w-100 border-bottom pt-3 '
              style={{ outline: 'none', border: 'none' }}
              onChange={(e) => setValue(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer style={{ border: 'none' }}>
          <div className={style.actionbuttons}>
            <button
              className={style.saveButton + ' ' + 'btn'}
              onClick={editingData}
            >
              Save Changes{' '}
              {loading && (
                <div
                  className='spinner-border spinner-border-sm text-white'
                  role='status'
                >
                  <span className='sr-only'>Loading...</span>
                </div>
              )}
            </button>
            <button
              className={style.cancelButton + ' ' + 'btn'}
              onClick={() => setModalShow(false)}
            >
              Discard
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}
